export default __webpack_public_path__ + "static/media/mineImg.c9a4cf27.png";